import {Hub} from 'aws-amplify';

const arrCallback = [];

console.log('registrando hub listen');
Hub.listen('auth', (data) => {
    if(data.payload.event === "signIn"){
        arrCallback.forEach(callback => {
            callback && callback(data);
        });  
    }
});


const registerOnSuccessSignin = (callback) => {
    arrCallback.push(callback);
}


const unregisterOnSuccessSignin = (callback) => {
    const indice = arrCallback.indexOf(callback);
    if(indice >=0 ){
        arrCallback.splice(indice, 1);
    }
}


export {registerOnSuccessSignin, unregisterOnSuccessSignin};